import {
  combineReducers,
  createStore as createReduxStore,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';

import reducers from './reducers';
import { defaultState } from './reducers/playback';

const rootReducer = combineReducers(reducers);

export default function createStore(player) {
  return createReduxStore(
    rootReducer,
    {
      playback: {
        ...defaultState,
        audioTrack: player.model.selectedAudio,
        subtitleTrack: player.model.selectedText,
        bitrate: player.model.selectedBitrate,
        isAirPlayAvailable: player.model.isAirPlayAvailable,
        isAirPlaying: player.model.isAirPlaying || false,
        isFullscreen: player.model.isFullscreen,
        chromecastEnabled: player.model.chromecast.enabled || false,
        airplayEnabled: player.model.airplayEnabled || false,
        muxKey: player.model.muxKey || false,
        nextVideo: player.model.nextVideo,
      },
    },
    applyMiddleware(thunk),
  );
}
